import { useEffect } from 'react';

import { PublicRoute } from '../app/guards';
import { COMPANY_NAME, DEFAULT_PAGE_TITLE } from '../brand';
import { useTitle } from '../contexts/TitleContext';
import termsHtml from '../static/terms-of-use.html?raw';

export function TermsOfUsePage() {
  const { setTitle } = useTitle();
  useEffect(() => {
    setTitle(`Terms of Use - ${COMPANY_NAME}`);
    return () => setTitle(DEFAULT_PAGE_TITLE);
  }, [setTitle]);
  return (
    <PublicRoute static>
      <div className="page-container">
        <div dangerouslySetInnerHTML={{ __html: termsHtml }} />
      </div>
    </PublicRoute>
  );
}
